export default __webpack_public_path__ + "static/media/oybek.1265ffa1.png";